import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { Facets, HighCommissionBoosting } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      {
        newName: Facets.NAME,
        oldNameMatcher: /^plp_facets/m,
      },
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
    ],
  });
};
